<template>
  <Teleport to="#header-demo-stamp">
    <v-menu location="bottom" :close-on-content-click="true">
      <template #activator="{ props }">
        <button v-bind="props" type="button" class="demo-header-stamp" >
          {{ t('header.demoStamp') }}
        </button>
      </template>
      <div class="demo-header-explanation" role="note">{{ t('athleteDevelopment.preview') }}</div>
    </v-menu>
  </Teleport>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style scoped>
.demo-header-stamp {
  display: block;
  padding: 2px 9px;
  border: 2px solid #80ceff;
  border-radius: 4px;
  background: #095d98;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  transform: rotate(-8deg);
  box-shadow: 0 2px 5px #09061f60;
  cursor: pointer;
}
.demo-header-stamp:focus-visible { outline: 2px solid white; outline-offset: 3px; }
.demo-header-explanation {
  max-width: min(340px, calc(100vw - 32px));
  padding: 16px;
  border: 1px solid #80ceff;
  border-radius: 10px;
  background: #edf8ff;
  color: #154465;
  font-size: 14px;
  line-height: 1.5;
  box-shadow: 0 6px 24px #09061f30;
}
</style>
